module.exports = __webpack_public_path__ + "assets/img/lltwo.93a98c36.png";